module.exports = __webpack_public_path__ + "static/media/Building B-2-Meter_MDB-C.1ee2a712.jpg";